<template lang="pug">
#sub-empresa-bloco-informacoes
    el-skeleton(:loading='carregando', animated)
        template(slot='template')
            .skeleton-bloco-informacoes__interno
                el-skeleton-item.icone(variant='circle')

                .width-interno
                    el-skeleton-item(variant='p')
                    el-skeleton-item.width-interno(variant='p')

                el-skeleton-item.numero(variant='rect')
        template
            slot
</template>

<script>
export default {
    name: 'SubEmpresaSkeletonBlocoInformacoes',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss">
#sub-empresa-bloco-informacoes {
    .width-interno {
        width: 50%;
    }

    .skeleton-bloco-informacoes__interno {
        min-height: 89px;
        min-width: 19vw;
        border-radius: 10px;
        background: #d6d6d6;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .icone {
            width: 28px;
            height: 28px;
        }

        .numero {
            width: 10%;
            height: 30px;
        }
    }
}
</style>
